module.exports = __webpack_public_path__ + "img/TractionAndroid.0b735da7.png";